/* eslint-disable react/no-danger */
import React from 'react';

import DOMPurify from 'isomorphic-dompurify';

import Button from '@/components/Button';
import Modal from '@/components/Modal';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';

import styles from './ClaimBookingStep.module.scss';

type DeactivatedInfoModalProps = {
  isVisible: boolean;
  onClose: () => void;
};

const DeactivatedInfoModal: React.FC<DeactivatedInfoModalProps> = ({
  isVisible,
  onClose,
}: DeactivatedInfoModalProps) => {
  const appUiData = useAppUiData();
  if (!isVisible) {
    return null;
  }
  const subText = appUiData[appUiIds.claimBooking.deactivatedAccountsSubtext];
  const modalCloseType = 'arrow-close-right';
  return (
    <Modal
      parentModalStateChangeHandler={onClose}
      contentClassName={styles.deactivatedInfoModal}
      modalName={modalCloseType}
      handleIgnoreChanges={onClose}
    >
      <div className={styles.deactivatedModalContent}>
        <div className={styles.deactivatedModalBody}>
          <h1 className={styles.deactivatedModalTitle}>{appUiData[appUiIds.claimBooking.deactivatedAccounts]}</h1>
          <div
            className={styles.deactivatedModalSubText}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(subText) }}
          />
          <Button variant="payment-card" onClick={onClose}>
            {appUiData[appUiIds.commonLabels.gotIt]}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeactivatedInfoModal;
